<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import izlemetablosu from "../StrRaporlar/StrGostergeTablolari/izlemetablosu.vue";
import verigirisdurumlaritablosu from "../StrRaporlar/StrGostergeTablolari/verigirisdurumlaritablosu.vue";
import hedefgerceklesmetablosu from "../StrRaporlar/StrGostergeTablolari/hedefgerceklesmetablosu.vue";
import hedeftoplamlaritablosu from "../StrRaporlar/StrGostergeTablolari/birimbazlihedeftoplamlaritablosu.vue";
import birimhedefgirisoranlaritablosu from "../StrRaporlar/StrGostergeTablolari/birimhedefgirisoranlaritablosu.vue";
import birimhedeftutturmaoranlaritablosu from "../StrRaporlar/StrGostergeTablolari/birimhedeftutturmaoranlaritablosu.vue";
import amacbazlistrplandegtablosu from "../StrRaporlar/StrGostergeTablolari/amacbazlistratejikplandegerlendirmetablosu.vue";
import hedefkarti from "../StrRaporlar/StrGostergeTablolari/hedefkarti.vue";
import stratejikplandegerlendirmetablosu from "../StrRaporlar/StrGostergeTablolari/stratejikplandegerlendirmetablosu.vue";
import BirimSecimi from "../FormComponet/BirimSecimiAnaBirim.vue";
import spbirimgostergedegerlendirmeformu from "../StrRaporlar/StrGostergeTablolari/spbirimgostergedegerlendirmeformu.vue";
import hatasayilari from "../StrRaporlar/StrGostergeTablolari/hatasayilari.vue";
export default {
  mixins: [Api, Sabit],
  page: {
    title: "Gösterge Girişi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    BirimSecimi,
    izlemetablosu,
    verigirisdurumlaritablosu,
    hedefgerceklesmetablosu,
    hedeftoplamlaritablosu,
    birimhedefgirisoranlaritablosu,
    birimhedeftutturmaoranlaritablosu,
    hedefkarti,
    stratejikplandegerlendirmetablosu,
    amacbazlistrplandegtablosu,
    spbirimgostergedegerlendirmeformu,
    hatasayilari
  },
  data() {
    return {
      title: "Gösterge Tabloları",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kurumsal Performans",
          active: true,
        },
        {
          text: "Gösterge Tabloları",
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },
      counter: 0,
      UstDonemId: null,
      secilen_birim: "",
      secilen_donem: "",
      secilen_alt_donem: "",
      ComboboxDonemler: [],
      ComboboxTablolar: [],
      ComboboxGDonemler: [],
      ComboboxBirimler: [],
      YuklenenTablolar: [],
      TabloDetaylar: [],
      Isbirlikciler: [],
      TabloDetay: {},
      Secilen: null,
      sorgula: 0,
      Raporgirisid: "",
      DetayId: "",
      TabloDetayAciklama: "",
      DonemId: "",
      Hesaplanmasin: "",
      AltDonemlerDetay: [],
      BirimId: 0,
      Tablo: 0,
      Filter: {
        DonemId: "",
        GdonemId: "",
        TabloId: "",
        BirimId: null,
      },
    };
  },

  methods: {
    /* ANCHOR Combobox yükleme metodları */
    gdonem_combo_yukle(ust_id) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.Filter.GdonemId = "";
      this.Filter.TabloId = "";

      this.UstDonemId = ust_id;

      this.ComboboxGDonemler = [];

      let Filter = "&UstId=" + ust_id + "&VeriTipi=3" + "&Asc=sira";
      this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: Filter }).then((res) => {
        this.ComboboxGDonemler = res.Data;
      });


      this.tum_tablolari_yukle();


    },
    /*
    birim_combo_yukle() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

          this.ActionsGet({"Service":"OBirim", "Page":Page}).then((res) => {

            this.ComboboxBirimler = res.Data;

          });
    },
*/
    Secilmis_Idler(secilmis) {

      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      if (typeof secilmis == 'string') {
        this.BirimId = 1;
        this.Filter.BirimId = this.secilen_birim
        this.ComboboxTablolar = [];
        let tum_tablolar = [];
        let Filter = "&DonemId=" + this.Filter.DonemId + "&Asc=Adi";
        this.ActionsFilterGet({ Service: "StrPerfTablo", Page: Page, Filter: Filter }).then((res) => {
          tum_tablolar = res.Data;

          if (this.secilen_birim != "" && this.secilen_birim != null) {
            let Page = {
              PageNumber: "1",
              PageSize: "9999",
            };

            let Filter = "&BirimId=" + this.secilen_birim + "&DonemId=" + this.UstDonemId;


            this.ActionsFilterGet({ Service: "StrBirimGosterge", Page: Page, Filter: Filter }).then((res) => {
              this.Isbirlikciler = res.Data;
              let tablo = [];
              if (this.Isbirlikciler.length > 0) {


                for (var s = 0; s < tum_tablolar.length; s++) {

                  for (var i = 0; i < this.Isbirlikciler.length; i++) {

                    if (this.Isbirlikciler[i].Tabloid == tum_tablolar[s].Id) {
                      tablo.push(tum_tablolar[s]);
                    }

                  }

                }
                this.ComboboxTablolar = tablo;

              } else {
                this.ComboboxTablolar = [];
              }

            });

            // this.secilen_birim="";
          }
        });




        if (secilmis != null) {
          this.tablo_combo_yukle(secilmis);
          this.secilen_birim = secilmis;
        }
      } else {
        this.BirimId = 0;
        this.Filter.BirimId = null;
        this.tum_tablolari_yukle();
        this.TabloGetAgain();
        this.Tablo = 0;
        this.sorgula = 0;
   
      }


    },


    tum_tablolari_yukle() {

      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      this.ComboboxTablolar = [];
      let tum_tablolar = [];
      let Filter = "&DonemId=" + this.Filter.DonemId + "&Asc=SiraNo";
      this.ActionsFilterGet({ Service: "StrPerfTablo", Page: Page, Filter: Filter }).then((res) => {
        tum_tablolar = res.Data;
        this.ComboboxTablolar = tum_tablolar;

      });

    },
    tablo_combo_yukle(birim_id) {
      if (this.Filter.DonemId != null && this.Filter.DonemId != "") {
        this.secilen_birim = birim_id;
        this.secilen_donem = this.UstDonemId;

        //this.gdonem_combo_yukle(this.UstDonemId);
      } else {
        this.makeToast();
      }
    },

    /* ANCHOR yükleme butonu kodu */
    tablo1_yukle() {

      if (this.Filter.TabloId != "" && this.Filter.TabloId != null && this.Filter.DonemId != "" && this.Filter.DonemId != null
        && this.Filter.GdonemId != "" && this.Filter.GdonemId != null) {

        this.Tablo = 1;
        this.sorgula = 1;

      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo1Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 1000;

        Vue.swal(this.Message);
      }
    },

    tablo2_yukle() {

      if (this.Filter.DonemId != "" && this.Filter.DonemId != null && this.Filter.GdonemId != "" && this.Filter.GdonemId != null
        && this.secilen_birim != "" && this.secilen_birim != null) {

        this.Tablo = 2;
        this.sorgula = 2;

      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo2Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 2000;

        Vue.swal(this.Message);
      }
    },
    tablo3_yukle() {

      if (this.Filter.DonemId != "" && this.Filter.DonemId != null && this.Filter.GdonemId != "" && this.Filter.GdonemId != null) {

        this.Tablo = 3;
        this.sorgula = 3;

      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo3Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 2000;

        Vue.swal(this.Message);
      }
    },

    tablo4_yukle() {

      if (this.Filter.DonemId != "" && this.Filter.DonemId != null && this.Filter.GdonemId != "" && this.Filter.GdonemId != null) {

        this.Tablo = 4;
        this.sorgula = 4;

      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo4Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 1000;

        Vue.swal(this.Message);
      }
    },
    tablo5_yukle() {

      if (this.Filter.DonemId != "" && this.Filter.DonemId != null && this.Filter.GdonemId != "" && this.Filter.GdonemId != null) {

        this.Tablo = 5;
        this.sorgula = 5;

      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo5Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 1000;

        Vue.swal(this.Message);
      }
    },
    tablo6_yukle() {
      if (this.Filter.DonemId != "" && this.Filter.DonemId != null && this.Filter.GdonemId != "" && this.Filter.GdonemId != null) {
        this.Tablo = 6;
        this.sorgula = 6;
      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo6Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 1000;
        Vue.swal(this.Message);
      }
    },
    tablo7_yukle() {
      if (this.Filter.DonemId != "" && this.Filter.DonemId != null && this.Filter.GdonemId != "" && this.Filter.GdonemId != null) {
        this.Tablo = 7;
        this.sorgula = 7;
      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo7Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 1000;
        Vue.swal(this.Message);
      }
    },
    tablo8_yukle() {
      if (this.Filter.DonemId != "" && this.Filter.DonemId != null && this.Filter.GdonemId != "" && this.Filter.GdonemId != null && this.Filter.TabloId != "" && this.Filter.TabloId != null) {
        this.Tablo = 8;
        this.sorgula = 8;
      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo8Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 1000;
        Vue.swal(this.Message);
      }
    },
    tablo9_yukle() {
      if (this.Filter.DonemId != "" && this.Filter.DonemId != null) {
        this.Tablo = 9;
        this.sorgula = 9;
      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo9Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 1000;
        Vue.swal(this.Message);
      }
    },
    tablo10_yukle() {
      if (this.Filter.DonemId != "" && this.Filter.DonemId != null && this.Filter.GdonemId != "" && this.Filter.GdonemId != null && this.Filter.TabloId != "" && this.Filter.TabloId != null && this.Filter.BirimId != null) {
        this.Tablo = 10;
        this.sorgula = 10;
      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo10Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 1000;
        Vue.swal(this.Message);
      }
    },
    tablo11_yukle() {
      if (this.Filter.DonemId != "" && this.Filter.DonemId != null && this.Filter.GdonemId != "" && this.Filter.GdonemId != null) {
        this.Tablo = 11;
        this.sorgula = 11;
      } else {
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = this.$t('GostergeTablolari.Page.Tablo11Mesaj');
        this.Message.showConfirmButton = false;
        this.Message.timer = 1000;
        Vue.swal(this.Message);
      }
    },
    Get() {

    },

    ChangePage(DefaultPage) {
      if (DefaultPage) {
        this.Page.PageNumber = DefaultPage;
        this.Get();
      }
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },

  created() {
    this.Get();

    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    let sorgu = "&Tip=1561";
    let Tip = [];

    this.ActionsFilterGet({ Service: "OKeyValues", Page: Page, Filter: sorgu }).then((res) => {

      for (var i = 0; i < res.Data.length; i++) {
        if (res.Data[i].Kod == 1 || res.Data[i].Kod == 2) {

          Tip.push(res.Data[i].Id);

        }

      }

      let altsorgu = "&UstIdDoluMu=false&Approval=true";

      let tipler = "";

      for (var s = 0; s < Tip.length; s++) {

        tipler = tipler + "&TipId=" + Tip[s];

      }

      altsorgu = altsorgu + tipler;



      this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {

          this.ComboboxDonemler.push(res.Data[i]);

        }
      });

    });





    this.ActionsGet({ "Service": "OBirim", "Page": Page }).then((res) => {
      this.ComboboxBirimler = res.Data;
    });
  },

  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <!-- ANCHOR Filtreleme form alanı -->

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">

                  <b-form-group class="mb-3" id="donemler" label="" label-for="text">
                    <select v-model="Filter.DonemId" @change="gdonem_combo_yukle(Filter.DonemId)" class="form-select"
                      type="text">
                      <option value="">{{ $t('StrGostergeGirisi.Filtreleme.UstId') }}</option>
                      <option v-for="DonemVerileri in ComboboxDonemler" :key="DonemVerileri.Id" :value="DonemVerileri.Id">
                        {{ DonemVerileri.Aciklama }}
                      </option>
                    </select>
                  </b-form-group>
                  <!--{{Filter.DonemId}}-->


                  <b-form-group class="mb-3" id="gdonemler" label="" label-for="text">
                    <select v-model="Filter.GdonemId" class="form-select" type="text">
                      <option value="">{{ this.$t('StrGostergeGirisi.Filtreleme.DonemId') }}</option>
                      <option v-for="DonemVerileri in ComboboxGDonemler" :key="DonemVerileri.Id"
                        :value="DonemVerileri.Id">
                        {{ DonemVerileri.Aciklama }}
                      </option>
                    </select>
                  </b-form-group>
                  <!-- {{Filter.GdonemId}} -->

                  <BirimSecimi :title="''" :title_class="'mb-3'" :closeOnSelect="true" :sutun="'0'" :multiple="false"
                    :YetkiKontrol="0" :personel_id="null" :BirimTipId="null" @Secilmis_Idler="Secilmis_Idler($event)" />
                  <!--   {{secilen_birim}}  -->

                  <b-form-group class="mb-2" id="gdonemler" label="" label-for="text">
                    <select v-model="Filter.TabloId" class="form-select" type="text">
                      <option value="">{{ this.$t('StrGostergeGirisi.Filtreleme.TabloId') }}</option>
                      <option v-for="Tablolar in ComboboxTablolar" :key="Tablolar.Id" :value="Tablolar.Id">
                        {{ Tablolar.Adi }}
                      </option>
                    </select>
                  </b-form-group>
                  <!-- {{Filter.TabloId}} -->

                </div>

                <!-- ANCHOR Rapor Çıktıları alanı -->
                <div class="col-md-8">

                  <div class="table-responsive">
                    <table class="table table-nowrap table-centered table-hover mb-0 align-middle">
                      <tbody>
                        <tr>
                          <td width="500">
                            <h5 class="font-size-14 mb-0">
                              <!--İzleme Tablosu - Strateik Plan İzleme Formu-->
                              <a href="javascript: void(0);" @click="tablo1_yukle()" class="text-dark">
                                <i class="fas fa-print"></i>
                                <span style="margin-left: 10px;">{{ this.$t('StrGostergeGirisi.Raporlar.it') }}</span>
                              </a>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-0">
                              <!--Birim Hedef Tutturma Oranları Tablosu-->
                              <a href="javascript: void(0);" @click="tablo3_yukle()" class="text-dark"> <i
                                  class="fas fa-print"></i>
                                <span
                                  style="margin-left: 10px;">{{ this.$t('StrGostergeGirisi.Raporlar.Hgeot') }}</span></a>
                            </h5>
                          </td>
                        </tr>
                        <tr>

                          <td>
                            <h5 class="font-size-14 mb-0">
                              <!--verigirisdurumlaritablosu - Onay Yapan Birimler Tablosu-->
                              <a href="javascript: void(0);" @click="tablo4_yukle()" class="text-dark"> <i
                                  class="fas fa-print"></i>
                                <span style="margin-left: 10px;">
                                  {{ this.$t('StrGostergeGirisi.Raporlar.Vgdt') }}
                                </span></a>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-0">
                              <!--Hedef kartı-->
                              <a href="javascript: void(0);" @click="tablo5_yukle()" class="text-dark"> <i
                                  class="fas fa-print"></i>
                                <span style="margin-left: 10px;">{{ this.$t('StrGostergeGirisi.Raporlar.Hk') }}</span></a>
                            </h5>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h5 class="font-size-14 mb-0">
                              <!--Birim Hedef Giriş Oranı Tablosu-->
                              <a href="javascript: void(0);" @click="tablo7_yukle()" class="text-dark"> <i
                                  class="fas fa-print"></i>
                                <span
                                  style="margin-left: 10px;">{{ this.$t('StrGostergeGirisi.Raporlar.Hgiot') }}</span></a>
                            </h5>
                          </td>
                          <!--  <td>
                                 <h5 class="font-size-14 mb-0"> -->
                          <!-- hedefgerceklesmetablosu  -  Birim Gösterge Tablosu  -->
                          <!--    <a
                                    href="javascript: void(0);"
                                    @click="tablo2_yukle()"
                                    class="text-dark"
                                    > <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">{{this.$t('StrGostergeGirisi.Raporlar.Hgt')}}</span></a
                                  >
                                </h5>
                              </td> -->
                          <td>
                            <h5 class="font-size-14 mb-0">
                              <!--Kurum / Birim Hedef Karşılaştırma Tablosu-->
                              <a href="javascript: void(0);" @click="tablo6_yukle()" class="text-dark"> <i
                                  class="fas fa-print"></i>
                                <span style="margin-left: 10px;">
                                  {{ this.$t('StrGostergeGirisi.Raporlar.Bbhtt') }}
                                </span></a>
                            </h5>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h5 class="font-size-14 mb-0">
                              <!--Stratejik Plan Yıllık Gerçekleşme Oranları Tablosu-->
                              <a href="javascript: void(0);" class="text-dark"> <i class="fas fa-print"></i>
                                <span style="margin-left: 10px;">
                                  {{ this.$t('StrGostergeGirisi.Raporlar.Spdta') }}
                                </span></a>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 mb-0">
                              <!-- Stratejik Plan Değerlendirme Formu-->
                              <a href="javascript: void(0);" @click="tablo8_yukle()" class="text-dark"> <i
                                  class="fas fa-print"></i>
                                <span style="margin-left: 10px;">
                                  {{ this.$t('StrGostergeGirisi.Raporlar.Spdt') }}
                                </span></a>
                            </h5>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h5 class="font-size-14 mb-0">
                              <!-- Stratejik Plan Değerlendirme Formu/Amac Bazlı-->
                              <a href="javascript: void(0);" @click="tablo9_yukle()" class="text-dark"> <i
                                  class="fas fa-print"></i>
                                <span style="margin-left: 10px;">
                                  {{ this.$t('StrGostergeGirisi.Raporlar.SpdtAB') }}
                                </span></a>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-0">
                              <!-- Birim Gösterge Değerlendirme Tablosu -->
                              <a href="javascript: void(0);" @click="tablo10_yukle()" class="text-dark"> <i
                                  class="fas fa-print"></i>
                                <span style="margin-left: 10px;">
                                  {{ this.$t('StrGostergeGirisi.Raporlar.SpdtBirimGosterge') }}
                                </span></a>
                            </h5>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h5 class="font-size-14 mb-0">
                              <!-- Stratejik Plan Onay Sayıları -->
                              <a href="javascript: void(0);" @click="tablo11_yukle()" class="text-dark"> <i
                                  class="fas fa-print"></i>
                                <span style="margin-left: 10px;">
                                  
                                  {{ this.$t('StrGostergeGirisi.Raporlar.HataDuzeltme') }}
                                </span></a>
                            </h5>
                          </td>
                          
                        </tr>

                      </tbody>
                    </table>
                  </div>

                  <br>
                  <br>
                </div>

              </div>
            </div>
          </div>
        </div>



      </div>


      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">

              <izlemetablosu v-if="Tablo == 1" :TabloId="Filter.TabloId" :BirimId="Filter.BirimId" :DonemId="Filter.DonemId"
                :AltDonemId="Filter.GdonemId" :Sorgulama="sorgula" />
              <birimhedeftutturmaoranlaritablosu v-if="Tablo == 3" :UstDonemId="Filter.DonemId" :DonemId="Filter.GdonemId"
                :BirimId="Filter.BirimId" :Sorgulama="sorgula" />

              <verigirisdurumlaritablosu v-if="Tablo == 4" :DonemId="Filter.DonemId" :AltDonemId="Filter.GdonemId"
                :Sorgulama="sorgula" />

              <hedefkarti v-if="Tablo == 5" :TabloId="Filter.TabloId" :DonemId="Filter.DonemId"
                :AltDonemId="Filter.GdonemId" :Sorgulama="sorgula" :Tablolar="ComboboxTablolar" />

              <hedefgerceklesmetablosu v-if="Tablo == 2" :BirimId="Filter.BirimId" :UstDonemId="Filter.DonemId"
                :DonemId="Filter.GdonemId" :Sorgulama="sorgula" />

              <hedeftoplamlaritablosu v-if="Tablo == 6" :UstDonemId="Filter.DonemId" :DonemId="Filter.GdonemId"
                :Sorgulama="sorgula" />

              <birimhedefgirisoranlaritablosu v-if="Tablo == 7" :UstDonemId="Filter.DonemId" :DonemId="Filter.GdonemId"
                :Sorgulama="sorgula" :BirimId="Filter.BirimId" />

              <stratejikplandegerlendirmetablosu v-if="Tablo == 8" :DonemId="Filter.GdonemId" :Sorgulama="sorgula"
                :TabloId="Filter.TabloId" :BirimId="Filter.BirimId" />

              <amacbazlistrplandegtablosu v-if="Tablo == 9" :UstDonemId="Filter.DonemId" :DonemId="Filter.GdonemId"
                :Sorgulama="sorgula" :TabloId="Filter.TabloId" />

                <spbirimgostergedegerlendirmeformu v-if="Tablo == 10" :UstDonemId="Filter.DonemId" :DonemId="Filter.GdonemId"
                :Sorgulama="sorgula" :TabloId="Filter.TabloId" :BirimId="Filter.BirimId" />

                <hatasayilari v-if="Tablo == 11" :UstDonemId="Filter.DonemId" :DonemId="Filter.GdonemId"
                :Sorgulama="sorgula" :BirimId="Filter.BirimId" />


            </div>
          </div>
        </div>
      </div>





    </Layout>
  </Loader>
</template>
